<template>
  <router-view class="estero router view" />
</template>

<style lang="scss" scoped>
@charset "utf-8";
@import '../../scss/variables';

// Hack: Pump up the rule priority with multiple classes
.estero.router.view {
  padding-left: 20px;
  padding-bottom: 20px;
  padding-top: 20px;
  padding-right: 30px;
  display: flex;
  flex-direction: column;
}
</style>

<script>
// @flow
export default {
  name: 'estero',

  props: {}
}
</script>
